<template>
<!-- 物资申请记录 -->
    <div class="declare-view">
        <Row type="flex" justify="space-between" align="middle">
            <div class="title-l" style="padding-bottom: 20px">
                <router-link to="/index/declare" class="span-box">
                    <Icon type="ios-arrow-back" />
                    <span>申请记录</span>
                </router-link>
            </div>
        </Row>
        <Row type="flex" style="align-items: center; margin-bottom: 14px">
            状态：
            <Select v-model="status" style="width:100px;">
                <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.label }}</Option>
            </Select>
            <Button type="primary" style="margin-left: 20px">
                <span @click="lookSearch">查询</span>
            </Button>
        </Row>
        <Table
            :columns="columns"
            :data="list"
            :height="520"
            ref="list">
            <template slot-scope="{ row }" slot="status">
                <span v-if="row.status === 0">未审批</span>
                <span v-if="row.status === 1">通过</span>
                <span v-if="row.status === 2">拒绝</span>
            </template>
            <template slot-scope="{ row }" slot="action">
                <Button size="small" v-if="row.status !== 1" @click="handleClick(row)" type="primary">修改</Button>
            </template>
        </Table>
        <div class="pages-footer">
            <Page
                :current="page.pageNumber"
                :total="page.total"
                show-sizer
                :page-size="page.pageSize"
                @on-page-size-change="getChangePageSize"
                @on-change="getChangePageNum"/>
        </div>
    </div>
</template>

<script>
import { getMyRequest } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';

export default {
    data() {
        return {
            list: [],
            page: {
                total: 0,
                pageNumber: 1,
                pageSize: 20
            },
            columns: [
                {
                    title: '操作',
                    slot: 'action',
                    width: 80
                },
                {
                    title: '物资名称',
                    key: 'productName',
                    minWidth: 100
                },
                {
                    title: '物资分类',
                    key: 'classifyName',
                    minWidth: 120
                },
                {
                    title: '物资规格',
                    key: 'productSpectype',
                    minWidth: 100
                },
                {
                    title: '物资单位',
                    key: 'productUnit',
                    minWidth: 100
                },
                {
                    title: '标准单位',
                    key: 'normalProductUnit',
                    minWidth: 100
                },
                {
                    title: '转化率',
                    key: 'rate',
                    minWidth: 100
                },
                {
                    title: '状态',
                    slot: 'status',
                    minWidth: 80
                },
                {
                    title: '原因',
                    key: 'reason',
                    minWidth: 240
                }
            ],
            modal: false,
            type: null,
            rowInfo: {},
            reason: '',
            status: 0,
            statusList: [
                {
                    label: '全部',
                    value: 0
                },
                {
                    label: '已通过',
                    value: 1
                },
                {
                    label: '已拒绝',
                    value: 2
                }
            ]
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        handleClick(row) {
            this.rowInfo = row;
            this.$router.push({
                path: '/index/record-modify',
                query: {
                    id: row.id
                }
            });
            const pageInfo = {
                pageNumber: this.page.pageNumber,
                pageSize: this.page.pageSize
            };
            window.sessionStorage.setItem('crowInfo', JSON.stringify(row));
            window.sessionStorage.setItem('cpageInfo', JSON.stringify(pageInfo));
        },
        getList() {
            this.$apollo.query({
                query: getMyRequest,
                variables: {
                    pageNumber: this.page.pageNumber,
                    pageSize: this.page.pageSize,
                    cliqueNo: Cookies.getJSON('cliqueNo').toString(),
                    supplierNo: `${Cookies.getJSON('USER-INFO').supplierNo}`,
                    condi: {
                        status: this.status
                    }
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.getMyRequest;
                if (data && data.data && data.code === 200) {
                    this.page.total = data.count;
                    this.list = data.data;
                }
            });
        },
        getChangePageNum(val) {
            this.page.pageNumber = val;
            this.getList();
        },

        // pagesize 变化
        getChangePageSize(size) {
            this.page.pageSize = size;
            this.getList();
        },
        lookSearch() {
            this.getList();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/declare/record.vue